import { render, staticRenderFns } from "./DeleteFileBtn.vue?vue&type=template&id=3e0458cd&"
import script from "./DeleteFileBtn.js?vue&type=script&lang=js&"
export * from "./DeleteFileBtn.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports